/**
 * 位置情報を**一度でも聞いたか**。
 *
 * 聞く場所は 2 つある (初回のオンボーディング / 既にオンボーディングを終えた人には HOME の
 * カード)。どちらで聞いても同じフラグを立て、二度は聞かない。断った人に何度も出すと、
 * ブラウザの設定で丸ごと拒否されて**位置が要る画面でも聞けなくなる**。
 *
 * 端末に残す (localStorage)。タブを閉じても「もう聞いた」は覚えておきたいため。
 */
const KEY = 'yokoso.locationAsked.v1'

export function hasAskedLocation(): boolean {
  try {
    return localStorage.getItem(KEY) === 'true'
  } catch {
    return false
  }
}

export function markLocationAsked(): void {
  try {
    localStorage.setItem(KEY, 'true')
  } catch {
    // localStorage unavailable — 覚えられないだけ (毎回聞くよりは出さない方に倒す)
  }
}
